<template>
    <!-- 오늘학습 -->
    <p v-if="isTop" class="full-width flex align-center item">
        <span :class="classForType">{{ typeName }} </span>
        <span v-if="props.one.passageArea" class="subject" style="display: inline-block; width: 6vw">{{ props.one.passageArea }} </span>
        <span v-if="props.one.learningType === '추천학습(진단)'" class="level" style="display: inline-block; width: 11vw">진단추천-{{props.one.groupIndex}}</span>
        <span v-if="props.one.learningType !== '추천학습(진단)'" class="level" style="display: inline-block; width: 11vw">{{ props.one.level }} &nbsp;&nbsp;{{ props.one.lesson }}</span>
        <template v-if="type !== 300 && type !== 700">
            <span class="passage" style="min-width: 10vw">{{ props.one.passageNumber }} &nbsp;-&nbsp;{{ props.one.passageClass }} </span>
            <span class="passageName"> {{ props.one.passageName }}</span>
        </template>
    </p>

    <!-- 학습기록 -->
    <div v-if="!isTop" class="full-width flex align-center justify-between">
        <p class="flex align-center" style="width: 90%; flex-wrap: nowrap;">
            <span :class="classForType">{{ typeName }} </span>
            <span v-if="props.one.learningType === '추천학습(진단)'" class="level" style="display: inline-block; width: 12vw">진단추천-{{props.one.groupIndex}}</span>
            <span v-if="props.one.learningType !== '추천학습(진단)'" class="level" style="display: inline-block; width: 12vw">{{ props.one.level }} &nbsp;&nbsp;{{ props.one.lesson }}</span>
            <div style="display: flex;flex-direction: row;align-items: center;width: 65%;">
                <span class="passage" style="max-width: 13vw">{{ props.one.passageNumber }} &nbsp;-&nbsp;{{ props.one.passageClass }}</span> 
                <span class="passage" style="flex: 1">{{ props.one.passageName }}</span>
            </div>
        </p>
        <p v-if="props.one.passageAccuracyRate > -1" class="percent">{{ props.one.passageAccuracyRate }}%</p>
    </div>

     
</template>

<script setup>
import { onMounted, computed, ref, watch, defineProps } from 'vue';
import Comm from '@/components/common.js';

const props = defineProps({
    isTop: {
        Type: Boolean,
        required: true,
    },
    one: {
        Type: Object,
        required: true,
    },
});

const type = computed(() => {
    return props?.one?.learningType ? Comm.getNoOfStudyType(true, props.one.learningType) : '';
});
const typeName = computed(() => {
    return Comm.getTypeNameOfStudyType(type.value);
});

// const levles = computed(() => {

//      props.one.level }} &nbsp;&nbsp;{{ props.one.lesson }}
//     return Comm.getTypeNameOfStudyType(type.value);
// });

const classForType = computed(() => {
    return Comm.getClassOfStudyType(type.value);
});

// const kind = computed(() => props.kind);

onMounted(() => {});
</script>

<style scoped lang="scss"></style>
